export default "__VITE_ASSET__eb96160b__"